import { mainCentersPathname } from '../../../../routes/centers/pathname'

export const urlBack = (centerType) => {
  if (centerType === 'OWNER') return mainCentersPathname.OWNER
  if (centerType === 'FRANCHISE') return mainCentersPathname.FRANCHISE
  if (centerType === 'OTHER') return mainCentersPathname.OTHER
  // return mainCentersPathname.CENTERS
  return mainCentersPathname.OWNER
}
